export const PREVIEW_QUERY_PARAMS = {
  layoutId: 'layout_id',
  routeParams: 'route_params',
  routeParamsPrefix: 'route_params[',
  authenticatedUser: 'authenticated_user',
  authenticatedUserId: 'authenticated_user[id]',
  authenticatedUserResourceId: 'authenticated_user[resource_id]'
} as const;

const PREVIEW_QUERY_PARAM_ROOTS = [
  PREVIEW_QUERY_PARAMS.layoutId,
  PREVIEW_QUERY_PARAMS.routeParams,
  PREVIEW_QUERY_PARAMS.authenticatedUser
];

export function previewRouteParamKey(key: string): string {
  return `${PREVIEW_QUERY_PARAMS.routeParamsPrefix}${key}]`;
}

export function isReservedPreviewQueryParam(key: string): boolean {
  return PREVIEW_QUERY_PARAM_ROOTS.some((root) => key === root || key.startsWith(`${root}[`));
}
